import { createSelector } from 'reselect'

import { selectQbrState } from './selectQbrState'

export const selectQBRFYear = createSelector([selectQbrState], (state) => state.fYear)
